import Vue from 'vue'
let vue = new Vue()
let baseUrl = vue.$cdn

export default{
  tech: {
    title: '核心技术',
    dec: [
      '四维看看Pro的核心研发团队由中德两国人工智能视觉领域专家共同组成，运用AI空间重构算法及3D空间大数据技术，',
      '让四维看看Pro能够即时捕捉空间点云信息，生成精准3D空间。'
    ],
    icon: ['空间定位', '空间重建', '空间展示'],
    location: {
      title: '空间定位',
      dec: '准确获取真实空间信息，包括拍摄点位置、空间结构点云数据等等。',
      eng:
          'The bi-spherical SfM technology that simulates human eyes captures real space information and measures space data.'
    },
    modeling: {
      title: '空间重建',
      dec: '根据相机采集位姿及对应的点云信息，自动生成空间平面图及立体结构。',
      eng:
          'Automatic calculation of a 3D digital model based on 2D images, and generation in five minutes without manual intervention.'
    },
    exhibition: {
      title: '空间展示',
      dec: '无需插件，可在手机、 平板、PC端、VR眼镜，实现720°沉浸式漫游体验。',
      eng:
          'View 3D scenes at 720° without plugins on the display terminals such as VR glasses, mobile phones, tablet PCs, and computers.'
    }
  },
  booking: {
    name: '四维看看 Pro',
    dec: '专业精准建模，高效复刻空间',
    price: '100元定金预售',
    btn: '立即购买',
    sub: '（首批预购用户，独享10G云容量5年使用权。）'
  },
  cases: {
    title: '行业应用展示',
    dec: [
      '四维看看已为消防、刑侦、文博等多个领域建立三维数字化空间档案，',
      '同时助力地产、酒店民宿、电商、餐饮等行业打造全新消费体验。'
    ],
    space: {
      title: '每个空间都值得被记录',
      sub: '迄今为止四维看看记录的空间数量',
      nums: [
        {
          text: '文博',
          count: 16893
        },
        {
          text: '地产',
          count: 32689
        },
        {
          text: '电商',
          count: 65682
        },
        {
          text: '餐饮',
          count: 42737
        },
        {
          text: '家居',
          count: 61368
        }
      ]
    }
  },
  items: [
    {url: 'https://www.4dkankan.com/showProPC.html?m=t-0Q99SHE',
      image: baseUrl + 'images/phone_11.png',
      icon: baseUrl + 'images/phone_icon_11.png',
      text: '黑白咖啡' },
    {url: 'https://www.4dkankan.com/showPC.html?m=x2kIkoCB',
      image: baseUrl + 'images/phone_7.jpg',
      icon: baseUrl + 'images/phone_icon_7.png',
      text: '万豪酒店' },
    {url: 'https://admin.4dmuseum.cn/showPC.html?m=241&bigScene&novr',
      image: baseUrl + 'images/phone_2.jpg',
      icon: baseUrl + 'images/phone_icon_2.png',
      text: '广东省博物馆' },
    {url: 'http://www.4dkankan.com/showPC.html?m=laaVIiT7',
      image: baseUrl + 'images/phone_3.jpg',
      icon: baseUrl + 'images/phone_icon_3.png',
      text: '海昏侯考古成果展' },
    {url: 'http://www.4dkankan.com/showPC.html?m=OOM185Kf',
      image: baseUrl + 'images/phone_4.jpg',
      icon: baseUrl + 'images/phone_icon_4.png',
      text: '华发地产' },
    {url: 'http://www.4dkankan.com/showPC.html?m=djryzBtW',
      image: baseUrl + 'images/phone_5.jpg',
      icon: baseUrl + 'images/phone_icon_5.png',
      text: '欧派橱柜' },
    {url: 'http://www.4dkankan.com/showPC.html?m=ImlLYDW8',
      image: baseUrl + 'images/phone_6.jpg',
      icon: baseUrl + 'images/phone_icon_6.png',
      text: '融信地产' },
    {url: 'https://www.4dkankan.com/showPC.html?m=X99yIvTq',
      image: baseUrl + 'images/phone_1.jpg',
      icon: baseUrl + 'images/phone_icon_1.png',
      text: '德国陶瓷博物馆' },
    {url: 'https://www.4dkankan.com/showPC.html?m=iTz0LxLs',
      image: baseUrl + 'images/phone_8.jpg',
      icon: baseUrl + 'images/phone_icon_8.png',
      text: '万科地产' },
    {url: 'https://www.4dkankan.com/showPC.html?m=0mVvxHHT',
      image: baseUrl + 'images/phone_9.jpg',
      icon: baseUrl + 'images/phone_icon_9.png',
      text: '伟星地产' },
    {url: 'https://admin.4dmuseum.cn/showApp.html?m=240&bigScene&novr',
      image: baseUrl + 'images/phone_10.jpg',
      icon: baseUrl + 'images/phone_icon_10.png',
      text: '宝鸡青铜博物院' }
  ],
  reports: {
    name: '媒体报道',
    items: [
      {
        icon: baseUrl + 'images/item_icon_7.png',
        cover: baseUrl + 'images/item_cover_7.png',
        time: '2019年5月17日',
        title: '四维时代发布新一代3D空间相机',
        url: 'https://proapi.jingjiribao.cn/detail.html?id=177829'
      },
      {
        icon: baseUrl + 'images/item_icon_8.png',
        cover: baseUrl + 'images/item_cover_8.png',
        time: '2019年5月31日',
        title: '「四维时代」发布新一代3D 空间相机，降低空间复刻成本',
        url: 'https://mp.weixin.qq.com/s/ui--KOL1hcmgob7935clBg'
      },
      {
        icon: baseUrl + 'images/item_icon_2.png',
        cover: baseUrl + 'images/item_cover_2.png',
        time: '2018年10月29日',
        title: '原科技部部长万钢视察四维时代 为四维看看及四维看展点赞',
        url: 'http://bj.news.163.com/18/1029/14/DV9U6QN8043897TC.html'
      },
      {
        icon: baseUrl + 'images/item_icon_4.png',
        cover: baseUrl + 'images/item_cover_4.png',
        time: '2018年11月19日',
        title: '四维时代发布手机端三维重建技术 助力AI产业发展',
        url: 'http://smart.huanqiu.com/viewpoint/2018-11/13585013.html'
      }
    ]
  },
  sequenceArr: [
    {
      name: '全自动精准建模，智能测距',
      img: 6,
      runAnimation: true
    },
    {
      name: '720度8K画质，身临其境',
      img: 7,
      runAnimation: true
    },
    {
      name: '10分钟入门，操作简易',
      img: 8,
      runAnimation: true
    },
    {
      name: '10分钟全自动出结果，高效快速',
      sub: '（约100平米空间）',
      img: 9,
      runAnimation: true
    },
    {
      name: '多功能编辑后台，让空间延伸表达',
      img: 10,
      runAnimation: true
    }
  ],
  services: {
    down: {
      txt: '3D相机控制APP',
      sub: '使用四维看看Pro的过程中，需要下载APP控制相机。请在手机软件商店搜索“四维看看Pro”或使用手机扫描二维码安装。'
    }
  },
  loginAside: {
    xieyi: '阅读至最底部，“确定”方可生效',
    cancel: '取消',
    comfirm: '确定',
    cluse: '我已阅读并同意四维看看用户协议',
    login: '登录',
    submit: '提交',
    scansub: '打开四维看看app扫一扫登录',
    loginsub1: '还没有账号？',
    loginsub2: '立即注册',
    resigter1: '已有账号，',
    resigter2: '直接登录 »',
    phone: {
      placeholder: '请输入手机号码'
    },
    password: {
      placeholder: '请输入密码'
    },
    code: {
      txt: '获取验证码',
      placeholder: '请输入验证码'
    },
    userName: {
      placeholder: '昵称'
    },
    newpass: {
      placeholder: '密码（最少8位以上数字和字母）'
    },
    comfirmpass: {
      placeholder: '再次输入密码（最少8位以上数字和字母）'
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/language/cn/home.js